var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-container"},[_c('GmapMap',{staticClass:"map",attrs:{"center":_vm.position,"zoom":_vm.zoom,"map-type-id":"terrain"}},[(_vm.hasCoords)?_c('GmapMarker',{attrs:{"position":_vm.position}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }